import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import * as $ from "jquery";
declare var $: any;

@Component({
  selector: 'app-activation-document',
  templateUrl: './activation-document.component.html',
  styleUrls: ['./activation-document.component.scss']
})
export class ActivationDocumentComponent implements OnInit {

  constructor(public LANG:CommonUtilitiesService) { }

  ngOnInit() {
    this.initowlCarouselProperties();
  }

  initowlCarouselProperties() {
    $("#owlGuideId").owlCarousel({
	  stageOuterClass: 'owl-stage-outer pt-3',
      nav: false,
      dots: true,
      loop: false,
      rewind: true,
      margin: 30,
      autoplay: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        630: {
          items: 2
        },
        991: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });
  }
}
